var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('span',[_c('div',{staticClass:"loader-overlay"}),_c('div',{staticClass:"progress_loader"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":100,"width":7}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }